import React, { ReactNode } from 'react';

import { View } from 'react-native';
import { StyleSheet } from 'react-native';

import Currency from 'components/currency';
import { CartItemOfferDiscount } from 'pages/cart/cart-item/cart-item-offer-discount';
import { CartItemOfferDiscountSkeleton } from 'pages/cart/cart-item/cart-item-offer-discount.skeleton';
import { useCartContext } from 'state/cart';
import { selectors, useAppSelector } from 'state/global-state';
import { t } from 'state/intl/translations';
import { theme } from 'styles/configure-theme';

import { GrandTotalLabel } from '../your-cart/totals/styled';

import { SkeletonStyled, TotalContainer } from './styled';

interface StickyFooterProps {
  priceTooLowCmp: ReactNode;
  CTAButton: ReactNode;
  isLoading: boolean;
  orderTotal: number;
}

export const CheckOutStickyFooter: React.FC<StickyFooterProps> = ({
  priceTooLowCmp,
  CTAButton,
  isLoading,
  orderTotal,
}) => {
  const { priceOrderFailure } = useCartContext();

  const appliedLoyaltyDiscountOffer = useAppSelector(
    selectors.loyalty.selectDiscountAppliedCmsOffer
  );

  const totalContainer = priceOrderFailure ? null : (
    <TotalContainer>
      <GrandTotalLabel fontSize={'xl'} flexGrow={0}>
        {t('total') + ': '}
      </GrandTotalLabel>
      <Currency
        testID="grand-total"
        amount={orderTotal}
        isBold
        textProps={{
          color: theme.token('text-default'),
          margin: 0,
          flexGrow: 0,
          fontSize: 'xl',
        }}
      />
    </TotalContainer>
  );

  return (
    <View testID="cart-payment" style={styles.buttonContainer}>
      {appliedLoyaltyDiscountOffer ? (
        isLoading ? (
          <CartItemOfferDiscountSkeleton selectedLoyaltyOffer={appliedLoyaltyDiscountOffer} />
        ) : (
          <CartItemOfferDiscount selectedLoyaltyOffer={appliedLoyaltyDiscountOffer} />
        )
      ) : null}
      {priceTooLowCmp}
      {isLoading ? <SkeletonStyled /> : totalContainer}
      {CTAButton}
    </View>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    alignItems: 'center',
    width: '100%',
  },
});
